<template>
  <fts-dropdown-select
    append-to-body
    placement="bottom-end"
    prevent-overflow-alt-axis
    prevent-overflow-tether-off
    append-toggle-class="assign-toggle"
    content-class="assign-content assign-dropdown-menu"
    :offset="[0, 6]"
    :disabled="disabled"
    stop-propagation-sibling-class
    stop-propagation-class="tippy-popper vs__dropdown-menu"
    @selected="submit"
    @show="show"
    @hide="hide">
    <!-- toggle -->
    <template slot="toggle">
      <!-- assignee -->
      <div class="assigned-assignee" :class="{'assignees': assignees.length > 1}" v-if="assignees.length">
        <template v-for="(x, ind) in assignees">
          <fts-profile 
            :userName="x.userName" 
            :profilePhotoSize="avatarSize"
            :profileName="assignees.length === 1 && !avatarMode" 
            :key="x.username" 
            class="assignee-profile" 
            :style="{ 'z-index': assignees.length - ind }" 
            v-if="x.type === 'profile'"/>
          
          <div v-else class="assignee-profile-count" :key="x.type">{{x.count}}</div>
        </template>
      </div>
      <!-- date -->
      <fts-tippy
        :content="moment(formData.due).format('ll')"
        class="assigned-due-wrapper"
        v-if="formData.due && moment(formData.due).isValid() && !disabledDate"
        :key="formData.id + formData.due">
        <div
          class="assigned-due"
          :class="{'assigned-due--overdue': overdue}"
          slot="trigger"
        >{{calendarRelativeTime}}</div>
      </fts-tippy>
      <!-- action -->
      <div class="assign-toggle-action" :class="{'ml': assignees.length || formData.due}" v-if="!disabled && !viewMode"> 
        <i class="fts-icon-user-plus" />
      </div>
      <!-- empty -->
      <div v-else></div>
    </template>
    <!-- menu -->
    <template #menu="{select}">
      <!-- close -->
      <div class="assign-close">
        <fts-btn text icon @click="select(false)">
          <font-awesome-icon :icon="['fas', 'times']" />
        </fts-btn>
      </div>
      <fts-assign
        :assign-data="assignData"
        :view="viewMode"
      />
      <template>
        <fts-comment
          :vectorId="module.id"
          :comment="assignData.comment"
          class="assign-comment"
          v-if="commentSection"
        />
        <div class="fts-text-right">
          <fts-btn sm color="primary" @click="select(true)">
            Done
          </fts-btn>
        </div>
      </template>
    </template>
  </fts-dropdown-select>
</template>

<script>
import moment from "moment";
import commons from '../commons/commons';
import { classificationStore } from "../store/classificationStore";

import FTSDropdownSelect from "./FTSDropdownSelect";
import FTSTippy from "./FTSTippy";
import FTSProfile from "./FTSProfile";
import FTSBtn from "./FTSBtn";
import FTSComment from "./FTSComment";
import FTSAssign from "./FTSAssign";

export default {
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    maxLength: {
      type: Number,
      default: 5
    },
    viewMode: Boolean,
    avatarMode: Boolean,
    avatarSize: {
      type: Number,
      default: 20,
    },
    commentSection: {
      type: Boolean,
      default: true,
    },
    disabledDate: Boolean,
    disabled: Boolean,
  },
  components: {
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-tippy": FTSTippy,
    "fts-profile": FTSProfile,
    "fts-btn": FTSBtn,
    "fts-comment": FTSComment,
    "fts-assign": FTSAssign,
  },
  data: () => ({
    assignData: {
      assignees: [],
      due: null,
      comment: {}
    },
  }),
  methods: {
    moment,
    show() {
      try {
        if (Array.isArray(this.formData.assignees))
          this.assignData.assignees = this.formData.assignees;
        else 
          throw 'error';
      } catch(err) {
        this.assignData.assignees = []
      }
      this.assignData.due = this.formData.due;
    },
    hide() {
      this.assignData = {
        assignees: [],
        due: null,
        comment: { }
      }
    },
    async submit(arg) {
      if (arg) {
        await classificationStore.dispatch('submitActivity', {
          activity: '#assign',
          post: this.assignData.comment,
          assignees: this.assignData.assignees,
          due: this.assignData.due ? moment(this.assignData.due).endOf('day') : null,
          name: this.module.name,
          ids: [this.formData.id]
        });
        this.$emit('refresh');
      }
      this.$emit('close');
    },
  },
  computed: {
    module() {
      return classificationStore.state.vector || {}
    },
    assignees() {
      const maxLength = this.maxLength
      let assignees = this.formData.assignees || []
      
      return maxLength && (assignees.length === maxLength + 1 || assignees.length > maxLength) ?
        assignees
          .slice(0, maxLength - 1)
          .map(x => ({ 
            userName: x, 
            type: 'profile' 
          }))
          .concat({ 
            type: 'other', 
            count: assignees.slice(maxLength - 1, assignees.length).length 
          }) : assignees.map(x => ({ userName: x, type: 'profile' }))
    },
    overdue() {
      if (this.formData && this.formData.due)
        return moment(this.formData.due).isBefore(moment().startOf('day'));
    },
    calendarRelativeTime() {
      if (this.formData && this.formData.due)
        return commons.calendarRelativeTime(this.formData.due);
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.assign-toggle {
  min-height: 20px;
  display: flex;
  align-items: center;
  .assigned-assignee {
    &:not(.assignees) {
      min-width: 0;
    }  
    display: flex;
    align-items: center;
    z-index: 1;
    .assignee-profile {
      &:not(:first-child) {
        margin-left: -0.275rem;
      }
    }
    .assignee-profile-count {
      @include flex-center-middle;
      height: 20px;
      min-width: 20px;
      margin-left: -0.275rem; 
      border-radius: 50%;
      background: var(--fts-gray-5);
      color: #fff;
      font-size: 75%;
    }
  }
  .assigned-due-wrapper {
    white-space: nowrap;
    .assigned-due { 
      color: var(--fts-gray-5);
      font-size: 90%;
      &.assigned-due--overdue {
        color: var(--fts-danger);
      }
    }
  }
  .assigned-assignee + .assigned-due-wrapper {
    margin-left: .375rem;
  }
  .assign-toggle-action {
    color: var(--fts-gray-5);
    transition: opacity .3s ease-in-out;
    :not(:hover) {
      opacity: .5;
    }
    &:hover {
      opacity: 1
    }
    cursor: pointer;
    &.ml {
      margin-left: .375rem;
    }
  }
}

.assign-content.assign-dropdown-menu {
  position: relative;
  max-height: 560px;
  width: 750px;
  padding: 1.5rem;
  cursor: initial;
  .assign-comment {
    margin-bottom: 1rem;
  }
  .assign-close {
    position: absolute;
    top: .375rem;
    right: .375rem;
    z-index: 10; /* datetimepicker overlay */
  }
}
</style>